import { createAction } from '@reduxjs/toolkit'

import { CurrentList, IdentityField } from 'common/actions/integrations/MailChimp/interfaces'

export const setCurrentList = createAction<CurrentList>(
  `integration/mailChimp/modal/setCurrentList`,
)

export const setIdentityField = createAction<IdentityField>(
  `integration/mailChimp/modal/setIdentityField`,
)
